import Cookies from 'js-cookie'
import getNextAPIURL from '../../api-utils/get-next-api-url'
import { getIsMobileClient } from '../web/get-is-mobile-client'
import { getErrorLogData } from './get-error-log-data'

export async function newrelicCustomEvents(
  customData: {
    error?: Error | unknown
    customErrorType?: string
    customErrString?: unknown
  } = {},
) {
  /* send type to identify the error type */
  // errorType = 'socket-error' | 'parsing-error'
  const isMobile = getIsMobileClient()
  const authToken = Cookies.get('token')
  const hasCookie = !!authToken

  if (process.env.NODE_ENV === 'development') {
    return
  }

  const newRelicAPIUrl = getNextAPIURL(`/api/newrelic`)

  const { error, ...rest } = customData || {}

  const data = {
    page: window.location.pathname,
    isMobile: isMobile.toString(),
    loggedIn: hasCookie.toString(),
    architecture: 'monorepo-stencil',
    ...rest,
    ...(error
      ? typeof error === 'object'
        ? { customError: JSON.stringify(getErrorLogData(error)) }
        : { customError: error }
      : {}),
  }

  try {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (navigator.sendBeacon) {
      navigator.sendBeacon(newRelicAPIUrl, JSON.stringify(data))
    } else {
      await fetch(newRelicAPIUrl, {
        method: 'POST',
        body: JSON.stringify(data),
        keepalive: true,
      })
    }
  } catch (e: unknown) {
    // opportunit for sentry push
  }
}
